<template>
  <div class="homePage">
    <!-- 路由的容器 -->
    <router-view style="padding-left:180px;"></router-view>
  </div>
</template>

<script>
export default {
}
</script>
<style scoped lang="scss">
.homePage{
  height: calc( 100% - 121px );
  min-width: 1120px;
  background: #F2F2F2;
  padding-bottom: 20px;
  padding-right: 20px;
  transition: padding-left .28s;
}
</style>
